import {
  lesson8Assignment2,
  lesson8Assignment3,
} from './assignments';
import { createChessboard } from '../../utils'
import { highlightCoordinates } from '../commonActivities'

let lessonConfig = [
  {
    id: 0,
    previous: null,
    next: 2,
    video: {
      src: 'img/videos/lesson_8/1.mp4',
      startTime: 0,
      autoStartNext: true,
      next: 1
    }
  },
  {
    id: 1,
    previous: 0,
    next: 2,
    chessboard: {
      board: highlightCoordinates({
        next: 2,
        showIndicators: { allSides: true },
        coordinates: ['.square-c4', '.square-c5', '.square-d5', '.square-e5', '.square-e4', '.square-e3', '.square-d3', '.square-c3'],
        position: { d4: 'wK' },
        coordinateClass: 'filled-cell',
        reminder: true,
      })
    },
    audio: { src: 'img/audio/lesson_8/1.mp3', start: true, controls: false },

    directions: {
      data: `<b>DIRECTIONS:</b> <br/>Click on all the <br/>squares adjacent, <br/>or next to, the King <br/>to see his <br/>Ring of Power.`,
      timeout: 9000
    }
  },
  {
    id: 2,
    previous: 0,
    next: 4,
    video: {
      src: 'img/videos/lesson_8/2.mp4',
      startTime: 0,
      autoStartNext: true,
      next: 3,
    }
  },
  {
    id: 3,
    previous: 2,
    next: 4,
    audio: { src: 'img/audio/lesson_8/2.mp3', start: true, controls: false },
    directions: {
      timeout: 16000,
      data: `<b>DIRECTIONS:</b> <br/>Click on the 7 <br/>squares closest <br/>to the white King <br/>where the Black <br/>King could stand.`
    },
    chessboard: {
      board: highlightCoordinates({
        next: 5,
        showIndicators: { allSides: true },
        coordinates: ['.square-e1', '.square-e2', '.square-e3', '.square-e4', '.square-f4', '.square-g4', '.square-h4'],
        position: { g2: 'wK' },
        coordinateClass: 'filled-cell-red',
        reminder: true,
      })
    }
  },
  {
    id: 4,
    previous: 2,
    next: 18,
    video: {
      src: 'img/videos/lesson_8/3.mp4',
      startTime: 0,
      autoStartNext: true,
      next: 6,
    }
  },
  {
    id: 5,
    previous: 2,
    next: 18,
    video: {
      src: 'img/videos/lesson_8/3.1.mp4',
      startTime: 0,
      autoStartNext: true,
      next: 6,
    }
  },
  {
    id: 6,
    previous: 4,
    next: 8,
    audio: { src: 'img/audio/lesson_8/3.mp3', start: true, controls: false },
    directions: {
      timeout: 0,
      data: `<b>DIRECTIONS:</b> <br/>Analyze the board, <br/>and decide how to <br/>get out of check. <br/>Click on your <br/>answer below`,
      className: 'no-animation'
    },
    options: {
      id: 2,
      next: 7,
      answer: [
        'Capture',
        'Block',
        'Escape'
      ],
      rightAnswer: 'a "Capture"',
      magnusWrongAnswer: {
        data: 'Oops...!!!<br/>It is actually a "Capture".',
        styleClass: 'xs',
        waitTime: 4000
      },
      validateAnswer: { rightAnswer: 0, userAnswer: -1 },
      styleClass: 'xs'
    },
    chessboard: {
      board: lesson8Assignment2({
        showIndicators: { allSides: true },
        position: '5qk1/5ppQ/5n1p/8/8/3B1N1P/2P2PP1/6K1',
        assignmentClass: 'custom-sparepiece',
        from: "square-h7",
        to: "square-g8",
        offset: [3, 3, 9, 9],
        next: 7
      }),
      canvas: true
    }

  },
  {
    id: 7,
    previous: 4,
    next: 8,
    chessboard: {
      board: lesson8Assignment3({
        showIndicators: { allSides: true },
        position: '5qk1/5ppQ/5n1p/8/8/3B1N1P/2P2PP1/6K1',
        finalPosition: '5qk1/5ppn/7p/8/8/3B1N1P/2P2PP1/6K1',
        assignmentClass: 'custom-sparepiece',
        from: "square-f6",
        to: "square-h7",
        offset: [ 8, 5, 2, 6],
        capture: {
          capturingPiece: 'bN',
          capturedPiece: 'wQ'
        },
        next: 8
      }),
      canvas: true
    }
  },
  {
    id: 8,
    previous: 6,
    next: 10,
    directions: {
      timeout: 0,
      data: `<b>DIRECTIONS:</b> <br/>Analyze the board, <br/>and decide how to <br/>get out of check. <br/>Click on your <br/>answer below`,
      className: 'no-animation'
    },
    options: {
      id: 2,
      next: 9,
      answer: [
        'Capture',
        'Block',
        'Escape'
      ],
      rightAnswer: 'a "Block"',
      magnusWrongAnswer: {
        data: 'Oops...!!!<br/>It is actually a "Block".',
        styleClass: 'xs',
        waitTime: 4000
      },
      validateAnswer: { rightAnswer: 1, userAnswer: -1 },
      styleClass: 'xs'
    },
    chessboard: {
      board: lesson8Assignment2({
        showIndicators: { allSides: true },
        position: '3R2k1/5ppp/8/8/8/b7/5P2/6K1',
        assignmentClass: 'custom-sparepiece',
        from: "square-d8",
        to: "square-g8",
        offset: [ 8, null, 1, null],
        next: 9
      }),
      canvas: true,
    }
  },
  {
    id: 9,
    previous: 6,
    next: 10,
    chessboard: {
      board: lesson8Assignment3({
        showIndicators: { allSides: true },
        position: '3R2k1/5ppp/8/8/8/b7/5P2/6K1',
        finalPosition: '3R1bk1/5ppp/8/8/8/8/5P2/6K1',
        assignmentClass: 'custom-sparepiece',
        from: "square-a3",
        to: "square-f8",
        offset: [ 8, 2, null, null],
        next: 10
      }),
      canvas: true
    }
  },
  {
    id: 10,
    previous: 8,
    next: 12,
    directions: {
      timeout: 0,
      data: `<b>DIRECTIONS:</b> <br/>Analyze the board, <br/>and decide how to <br/>get out of check. <br/>Click on your <br/>answer below`,
      className: 'no-animation'
    },
    options: {
      id: 2,
      next: 11,
      answer: [
        'Capture',
        'Block',
        'Escape'
      ],
      rightAnswer: 'a "Capture"',
      magnusWrongAnswer: {
        data: 'Oops...!!!<br/>It is actually a "Capture".',
        styleClass: 'xs',
        waitTime: 4000
      },
      validateAnswer: { rightAnswer: 0, userAnswer: -1 },
      styleClass: 'xs'
    },
    chessboard: {
      board: lesson8Assignment2({
        showIndicators: { allSides: true },
        position: '6k1/5pp1/7p/8/7P/3r2P1/1nq2P2/2K1R3',
        assignmentClass: 'custom-sparepiece',
        from: "square-c2",
        to: "square-c1",
        offset: [ null, 6, null, 1],
        next: 11
      }),
      canvas: true,
    }
  },
  {
    id: 11,
    previous: 8,
    next: 12,
    chessboard: {
      board: lesson8Assignment3({
        showIndicators: { allSides: true },
        position: '6k1/5pp1/7p/8/7P/3r2P1/1nq2P2/2K1R3',
        finalPosition: '6k1/5pp1/7p/8/7P/3r2P1/1nK2P2/4R3',
        assignmentClass: 'custom-sparepiece',
        from: "square-c1",
        to: "square-c2",
        offset: [ null, 1, null, 6],
        capture: {
          capturingPiece: 'wK',
          capturedPiece: 'bQ'
        },
        next: 12
      }),
      canvas: true
    }
  },
  {
    id: 12,
    previous: 10,
    next: 14,
    directions: {
      timeout: 0,
      data: `<b>DIRECTIONS:</b> <br/>Analyze the board, <br/>and decide how to <br/>get out of check. <br/>Click on your <br/>answer below`,
      className: 'no-animation'
    },
    options: {
      id: 2,
      next: 13,
      answer: [
        'Capture',
        'Block',
        'Escape'
      ],
      rightAnswer: 'a "Block"',
      magnusWrongAnswer: {
        data: 'Oops...!!!<br/>It is actually a "Block".',
        styleClass: 'xs',
        waitTime: 4000
      },
      validateAnswer: { rightAnswer: 1, userAnswer: -1 },
      styleClass: 'xs'
    },
    chessboard: {
      board: lesson8Assignment2({
        showIndicators: { allSides: true },
        position: '6k1/5pp1/7p/8/8/5RN1/5PPP/1q4K1',
        assignmentClass: 'custom-sparepiece',
        from: "square-b1",
        to: "square-g1",
        offset: [ 8, null, 1, null],
        next: 13
      }),
      canvas: true,
    }
  },
  {
    id: 13,
    previous: 10,
    next: 14,
    chessboard: {
      board: lesson8Assignment3({
        showIndicators: { allSides: true },
        position: '6k1/5pp1/7p/8/8/5RN1/5PPP/1q4K1',
        finalPosition: '6k1/5pp1/7p/8/8/5R2/5PPP/1q3NK1',
        assignmentClass: 'custom-sparepiece',
        from: "square-g3",
        to: "square-f1",
        offset: [ 2, 8, null, null],
        next: 14
      }),
      canvas: true
    }
  },
  {
    id: 14,
    previous: 12,
    next: 16,
    directions: {
      timeout: 0,
      data: `<b>DIRECTIONS:</b> <br/>Analyze the board, <br/>and decide how to <br/>get out of check. <br/>Click on your <br/>answer below`,
      className: 'no-animation'
    },
    options: {
      id: 2,
      next: 15,
      answer: [
        'Capture',
        'Block',
        'Escape'
      ],
      rightAnswer: 'an "Escape"',
      magnusWrongAnswer: {
        data: 'Oops...!!!<br/>It is actually an "Escape".',
        styleClass: 'xs',
        waitTime: 4000
      },
      validateAnswer: { rightAnswer: 2, userAnswer: -1 },
      styleClass: 'xs'
    },
    chessboard: {
      board: lesson8Assignment2({
        showIndicators: { allSides: true },
        position: '4R1k1/1p3p2/2p2Ppp/8/8/2P2rP1/1P3P2/6K1',
        assignmentClass: 'custom-sparepiece',
        from: "square-e8",
        to: "square-g8",
        offset: [ 8, null, 1, null],
        next: 15
      }),
      canvas: true,
    }
  },
  {
    id: 15,
    previous: 12,
    next: 16,
    chessboard: {
      board: lesson8Assignment3({
        showIndicators: { allSides: true },
        position: '4R1k1/1p3p2/2p2Ppp/8/8/2P2rP1/1P3P2/6K1',
        finalPosition: '4R3/1p3p1k/2p2Ppp/8/8/2P2rP1/1P3P2/6K1',
        assignmentClass: 'custom-sparepiece',
        from: "square-g8",
        to: "square-h7",
        offset: [ 8, 8, null, null],
        next: 16
      }),
      canvas: true
    }
  },
  {
    id: 16,
    previous: 14,
    next: 18,
    directions: {
      timeout: 0,
      data: `<b>DIRECTIONS:</b> <br/>Analyze the board, <br/>and decide how to <br/>get out of check. <br/>Click on your <br/>answer below.`,
      className: 'no-animation'
    },
    options: {
      id: 2,
      next: 17,
      answer: [
        'Capture',
        'Block',
        'Escape'
      ],
      rightAnswer: 'an "Escape"',
      magnusWrongAnswer: {
        data: 'Oops...!!!<br/>It is actually an "Escape".',
        styleClass: 'xs',
        waitTime: 4000
      },
      validateAnswer: { rightAnswer: 2, userAnswer: -1 },
      styleClass: 'xs'
    },
    chessboard: {
      board: lesson8Assignment2({
        showIndicators: { allSides: true },
        position: '4r1k1/5p2/2p2bpp/1b6/3K4/P1P3P1/1P3P2/3R3R',
        assignmentClass: 'custom-sparepiece',
        from: "square-f6",
        to: "square-d4",
        offset: [ 2, 8, 8, 2],
        next: 17
      }),
      canvas: true,
    }
  },
  {
    id: 17,
    previous: 14,
    next: 19,
    chessboard: {
      board: lesson8Assignment3({
        showIndicators: { allSides: true },
        position: '4r1k1/5p2/2p2bpp/1b6/3K4/P1P3P1/1P3P2/3R3R',
        finalPosition: '4r1k1/5p2/2p2bpp/1bK5/8/P1P3P1/1P3P2/3R3R',
        assignmentClass: 'custom-sparepiece',
        from: "square-d4",
        to: "square-c5",
        offset: [ 2, 2, 6, 6],
        next: 19
      }),
      canvas: true 
    }
  },
  {
    id: 18,
    previous: 4,
    next: 20,
    video: {
      src: 'img/videos/lesson_8/4.mp4',
      startTime: 0,
      autoStartNext: true,
      next: 20,
    }
  },
  {
    id: 19,
    previous: 4,
    next: 20,
    video: {
      src: 'img/videos/lesson_8/4.1.mp4',
      startTime: 0,
      autoStartNext: true,
      next: 20,
    }
  },
  {
    id: 20,
    previous: 18,
    next: 21,
    audio: { src: 'img/audio/qa_bgm.mp3', start: true, loop: true },
    qa: {
      id: 0,
      question: "On which files do the Kings start a game?",
      answer: [
        'd',
        'b',
        'f',
        'e'
      ],
      rightAnswer: 'e',
      validateAnswer: { rightAnswer: 3, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 21,
    previous: 18,
    next: 22,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 1,
      question: "How many points is the King worth?",
      answer: [
        '10',
        '25',
        '50',
        'Priceless'
      ],
      rightAnswer: 'Priceless',
      validateAnswer: { rightAnswer: 3, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 22,
    previous: 18,
    next: 23,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 2,
      question: "What is the King's symbol?",
      answer: [
        'C',
        'K',
        'B',
        'He has no symbol'
      ],
      rightAnswer: 'K',
      validateAnswer: { rightAnswer: 1, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 23,
    previous: 18,
    next: 24,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 3,
      question: "What does the King represent from the Middle Ages?",
      answer: [
        'The land owners',
        'The church',
        "The peasants",
        'The entire kingdom'
      ],
      rightAnswer: 'The entire kingdom',
      validateAnswer: { rightAnswer: 3, userAnswer: -1 },
      styleClass: 'md',
      rightAnswerTimeout: 7000
    }
  },
  {
    id: 24,
    previous: 18,
    next: 25,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 4,
      question: 'How does the King move?',
      answer: [
        'Across the ranks',
        'Up and down files',
        'On the diagonal',
        'One square any direction'
      ],
      rightAnswer: 'One square any direction',
      validateAnswer: { rightAnswer: 3, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 25,
    previous: 18,
    next: 26,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 5,
      question: 'What are the squares around the King called?',
      answer: [
        'The Guard House',
        'The Corral',
        'The Ring of Power',
        'The Castle'
      ],
      rightAnswer: 'The Ring of Power',
      validateAnswer: { rightAnswer: 2, userAnswer: -1 },
      styleClass: 'md'
    }
  }, {
    id: 26,
    previous: 18,
    next: 27,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 6,
      question: 'How do Kings Capture?',
      answer: [
        'On the diagonal',
        'By jumping over a pawn',
        'Along a file or rank',
        'One square any direction'
      ],
      rightAnswer: 'One square any direction',
      validateAnswer: { rightAnswer: 3, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 27,
    previous: 18,
    next: 28,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 7,
      question: 'Analyze the board to decide what is wrong about this setup',
      answer: [
        'There are too many pawns',
        'The Kings can\'t stand next to each other',
        'The black Bishop should be on a black diagonal',
        'The white Knight can\'t stand next to his own King'
      ],
      chessboard: {
        board: createChessboard({
          showIndicators: true,
          position: '2r5/p4p1p/1p2k1p1/2pNK3/8/6P1/1PP2PBP/8'
        }),
        hint: true
      },
      rightAnswer: 'The Kings can\'t stand next to each other',
      validateAnswer: { rightAnswer: 1, userAnswer: -1 },
      styleClass: 'lg'
    }
  },
  {
    id: 28,
    previous: 18,
    next: 29,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 8,
      question: 'Which piece could you move to put the white King in check?',
      answer: [
        'Have the e1 Knight capture the f3 pawn',
        'Move the d6 Rook to d3',
        'Have the e7 Queen capture the b7 Queen',
        'Move the Bishop to e5'
      ],
      chessboard: {
        board: createChessboard({
          showIndicators: true,
          position: '8/1Q2q1k1/3r4/1R5P/2P3P1/1P3PK1/Pb6/4n3'
        }),
        hint: true
      },
      rightAnswer: 'Move the Bishop to e5',
      validateAnswer: { rightAnswer: 3, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 29,
    previous: 18,
    next: 30,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 9,
      question: 'How can the black King get out of check?',
      answer: [
        'Use the Queen to capture the a7 Rook',
        'Have the King escape to h5',
        'Have the King escape to h6',
        'Move the Rook to e4'
      ],
      chessboard: {
        board: createChessboard({
          showIndicators: true,
          position: '8/R7/6k1/4P3/8/3B4/4P3/1KB1r1q1'
        }),
        hint: true
      },
      rightAnswer: 'Have the King escape to h5',
      validateAnswer: { rightAnswer: 1, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 30,
    previous: 18,
    next: null,
    audio: { src: null, stop: true },
    qa: {
      position: 'center',
      result: true,
      nextLesson: 'Lesson Nine',
      styleClass: 'xl'
    }
  }
];

let assets = [
  '/img/background_7.png',
  '/img/background_8.png',
  '/img/background_9.png'
];

let config = {
  config: lessonConfig,
  assets: assets
};

export default config;


// WEBPACK FOOTER //
// ./src/lessons/lesson_8/index.js